import React from "react";
import { Link } from "react-router-dom";

/**
 * Phase 13 — global, theme-aware footer.
 *
 * Surfaces the Accessibility statement link from every authenticated page
 * (mounted inside `AuthenticatedShell`) and is also embedded on the public
 * `/login` screen so the statement is reachable without signing in.
 */
export default function GlobalFooter({ compact = false }) {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="global-footer"
      className={
        "border-t " +
        (compact ? "px-4 py-2 text-[11px]" : "px-6 py-3 text-xs")
      }
      style={{
        borderColor: "var(--border-subtle)",
        backgroundColor: "var(--surface)",
        color: "var(--page-fg-muted)",
      }}
      aria-label="Site footer"
    >
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-2">
        <span data-testid="global-footer-copy">
          © {year} Goodwin Living · Goodwin Resolve
        </span>
        <nav
          aria-label="Footer navigation"
          className="flex items-center gap-3"
        >
          <Link
            to="/accessibility-statement"
            data-testid="footer-accessibility-link"
            className="font-medium transition-colors hover:text-[color:var(--page-fg)] focus-visible:underline"
          >
            Accessibility
          </Link>
        </nav>
      </div>
    </footer>
  );
}
